import { NgClass, NgForOf, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { BytesizeIconPipe } from '@portal/pipe';
import { MegaMenuItem } from '../mega-menu-item/mega-menu-item.interface';

@Component({
  selector: 'portal-ui-mega-menu-mobile',
  standalone: true,
  imports: [NgIf, NgClass, NgForOf, MatStepperModule, BytesizeIconPipe],
  templateUrl: './mega-menu-mobile.component.html',
  styles: [':host {@apply block;}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MegaMenuMobileComponent implements OnInit {
  @Input() menuTitle = '';
  @Input() menuItems: MegaMenuItem[] = [];
  @Output() resetStep = new EventEmitter<void>();
  @ViewChild('megaMenuMobileStepper') private _megaMenuMobileStepper?: MatStepper;

  menuHasChildren?: MegaMenuItem[];
  hideStepper = true;

  ngOnInit(): void {
    this.menuHasChildren = this.menuItems.filter(v => v.children && v.children.length > 0);
  }

  protected changeMegaMenuMobileStep(label: string): void {
    const step = this.menuHasChildren?.findIndex(v => v.label === label);

    if (step !== undefined && step > -1 && this._megaMenuMobileStepper) {
      this._megaMenuMobileStepper.selectedIndex = step;
      this.hideStepper = false;
    }
  }

  protected resetMegaMenuMobileStep(): void {
    this.hideStepper = true;
  }
}
